// Copied and rewritten from inflection.js, which includes a bunch of other helpers:
// https://github.com/dreamerslab/node.inflection/blob/master/lib/inflection.js
// Angular wrapper: https://github.com/konsumer/ngInflection/blob/gh-pages/dist/ngInflection.js

// This is a list of words that should not be capitalized for title case.
const nonTitlecasedWords = [
  'and',
  'or',
  'nor',
  'a',
  'an',
  'the',
  'so',
  'but',
  'to',
  'of',
  'at',
  'by',
  'from',
  'into',
  'on',
  'onto',
  'off',
  'out',
  'in',
  'over',
  'with',
  'for',
];

const capitalize = str => str.substring(0, 1).toUpperCase() + str.substring(1);

export function titleize(input) {
  if (['null', 'undefined'].includes(String(input))) {
    return '';
  }

  const cleanedInput = input.toLowerCase().replace(/_/g, ' ');

  const titleizedInput = cleanedInput
    .split(' ')
    .map(word =>
      word
        .split('-')
        .map(part =>
          nonTitlecasedWords.includes(part) ? part : capitalize(part)
        )
        .join('-')
    )
    .join(' ');

  return capitalize(titleizedInput);
}
